(() => {
  const dialog = document.querySelector('.tos-gift-offer');
  const rules = window.tosGiftOfferRules;
  const native = document.querySelector('cart-notification');
  const panel = document.getElementById('cart-notification');
  if (!dialog || !dialog.showModal || !rules || !native || !panel) return;

  const root = window.Shopify?.routes?.root || '/';
  const bag = dialog.querySelector('#tos-bag-toggle');
  const bagRow = dialog.querySelector('.tos-offer-bag');
  const addonsHeading = dialog.querySelector('[data-addons-heading]');
  const scrollToActions = dialog.querySelector('[data-scroll-to-actions]');
  const actions = dialog.querySelector('.tos-gift-actions');
  const cards = [...dialog.querySelectorAll('[data-addon-product-id]')];
  const zoom = dialog.querySelector('[data-image-zoom]');
  const zoomImage = zoom?.querySelector('img');
  let zoomOpener;
  const decline = dialog.querySelector('[data-decline]');
  const add = dialog.querySelector('[data-cart]');
  const status = dialog.querySelector('[role="status"]');
  const error = dialog.querySelector('[role="alert"]');
  const strings = JSON.parse(dialog.querySelector('[data-offer-strings]').textContent);
  const counter = document.createElement('span');
  counter.className = 'tos-offer-addons__counter';
  counter.setAttribute('aria-live', 'polite');
  addonsHeading.append(counter);
  let busy = false;
  let checking = false;
  let scrollHintDismissed = false;
  let addonLimit = 0;

  const inputs = () => [bag, ...cards.map(card => card.querySelector('input'))].filter(Boolean);
  const visibleInputs = () => inputs().filter(input => !input.closest('[hidden]'));
  const selected = () => visibleInputs().filter(input => input.checked);
  const selectedAddons = () => selected().filter(input => input.closest('.tos-offer-addon'));
  const readCart = async () => {
    const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const showError = () => {
    error.textContent = dialog.dataset.error;
    error.hidden = false;
    error.scrollIntoView({ block: 'nearest' });
  };
  const sync = () => {
    const hasSelection = rules.actionFor(selected().length) === 'add';
    decline.hidden = hasSelection;
    add.hidden = !hasSelection;
    const selectedCount = selectedAddons().length;
    counter.textContent = `${selectedCount} / ${addonLimit}`;
    inputs().forEach(input => {
      input.disabled = busy || (input.closest('.tos-offer-addon') && !input.checked && selectedCount >= addonLimit);
    });
    add.disabled = busy;
    decline.disabled = busy;
    dialog.setAttribute('aria-busy', String(busy));
  };
  const restoreNative = () => {
    native.removeAttribute('aria-hidden');
    status.textContent = '';
    error.hidden = true;
    if (panel.classList.contains('active')) {
      const checkout = panel.querySelector('[name="checkout"], .button');
      if (checkout) checkout.focus({ preventScroll: true });
    }
  };
  dialog.addEventListener('close', () => {
    if (zoom?.open) zoom.close();
    restoreNative();
  });
  dialog.addEventListener('cancel', event => event.preventDefault());
  // The native cart notification listens for body clicks and would otherwise
  // close behind the modal as soon as a customer uses a toggle or footer button.
  dialog.addEventListener('click', event => event.stopPropagation());
  dialog.addEventListener('keyup', event => {
    if (event.key === 'Escape') event.stopPropagation();
  });
  dialog.querySelectorAll('[data-image-zoom-open]').forEach(button => {
    button.addEventListener('click', () => {
      if (!zoom || !zoomImage || !button.dataset.zoomSrc) return;
      zoomOpener = button;
      zoomImage.src = button.dataset.zoomSrc;
      zoomImage.alt = button.dataset.zoomAlt || '';
      zoom.showModal();
      zoom.querySelector('[data-image-zoom-close]').focus();
    });
  });
  zoom?.querySelector('[data-image-zoom-close]')?.addEventListener('click', () => zoom.close());
  zoom?.addEventListener('close', () => zoomOpener?.focus({ preventScroll: true }));
  inputs().forEach(input => input.addEventListener('change', sync));
  decline.addEventListener('click', () => { if (!busy) dialog.close(); });
  const updateScrollHint = () => {
    scrollToActions?.classList.toggle('is-hidden', scrollHintDismissed || dialog.scrollHeight - dialog.clientHeight - dialog.scrollTop <= 24);
  };
  dialog.addEventListener('scroll', updateScrollHint, { passive: true });
  scrollToActions?.addEventListener('click', () => {
    scrollHintDismissed = true;
    scrollToActions.classList.add('is-hidden');
    dialog.scrollTo({ top: dialog.scrollHeight, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    actions?.querySelector('button:not([hidden])')?.focus({ preventScroll: true });
  });

  async function submit() {
    if (busy) return;
    busy = true;
    sync();
    status.textContent = strings.loading || '';
    error.hidden = true;
    const wanted = selected().map(input => ({
      productId: Number(input.dataset.productId || dialog.dataset.bagProduct),
      id: Number(input.value),
      quantity: 1,
      addon: Boolean(input.closest('.tos-offer-addon'))
    }));
    try {
      const cart = await readCart();
      const items = wanted.filter(item => !rules.inCart(item.productId, cart.items));
      const needsDiscount = wanted.some(item => item.addon);
      if (needsDiscount && (wanted.filter(item => item.addon).length > rules.availableAddonSlots(cart.items)
        || cart.items.some(item => rules.isAddonProduct(item.product_id))
        || cart.discount_codes?.some(discount => discount.applicable))) throw new Error('offer-changed');
      if (!items.length && !needsDiscount) {
        dialog.close();
        return;
      }
      const sections = native.getSectionsToRender().map(section => section.id);
      let data;
      let addedKey;
      if (items.length) {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items.map(({ id, quantity }) => ({ id, quantity })),
            sections,
            sections_url: window.location.pathname
          })
        });
        data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'add');
        addedKey = data.items?.[0]?.key;
      }
      if (needsDiscount) {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: dialog.dataset.addonsDiscount,
            sections,
            sections_url: window.location.pathname
          })
        });
        const discountedCart = await response.json();
        if (!response.ok || discountedCart.status) throw new Error(discountedCart.description || 'discount');
        const verifiedCart = await readCart();
        const applied = verifiedCart.discount_codes?.some(discount =>
          discount.code?.toUpperCase() === dialog.dataset.addonsDiscount.toUpperCase() && discount.applicable
        );
        const discountedAddonIds = wanted.filter(item => item.addon).map(item => item.id);
        const allDiscounted = discountedAddonIds.every(id => {
          const line = verifiedCart.items.find(item => Number(item.variant_id) === id);
          const discount = line?.discounts?.find(item => item.title?.toUpperCase() === dialog.dataset.addonsDiscount.toUpperCase());
          return discount && Math.abs(Number(discount.amount) * 2 - Number(line.original_price)) <= 1;
        });
        if (!applied || !allDiscounted) {
          const updates = Object.fromEntries(items.map(item => [item.id, 0]));
          const rollback = await fetch(`${root}cart/update.js`, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, discount: '' })
          });
          if (!rollback.ok) { window.location.assign(`${root}cart`); return; }
          throw new Error('discount-not-applied');
        }
        data = { ...discountedCart, items: verifiedCart.items };
      }
      const key = data.items?.find(item => wanted.some(selectedItem => selectedItem.id === Number(item.variant_id)))?.key || addedKey;
      if (data.sections && key) {
        native.renderContents({ ...data, key });
      } else {
        // The cart and discount succeeded; a rendering failure must not repeat either mutation.
        window.location.assign(`${root}cart`);
        return;
      }
      dialog.close();
    } catch (failure) {
      // Keep the choices visible. A retry checks the cart first and never adds lines twice.
      showError();
    } finally {
      busy = false;
      status.textContent = '';
      sync();
    }
  }
  add.addEventListener('click', submit);

  async function hasBagTag(handle) {
    if (!handle) return false;
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=tos-bag-eligibility`, {
      credentials: 'same-origin', cache: 'no-store'
    });
    if (!response.ok) return false;
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const payload = documentFragment.querySelector('[data-tos-bag-eligibility]');
    if (!payload) return false;
    const data = JSON.parse(payload.textContent);
    return Number(data.id) === Number(dialog.dataset.product) && rules.eligible(data.tags);
  }

  document.addEventListener('tos:cart-notification-ready', async event => {
    const productId = Number(event.detail?.product_id);
    if (checking || busy || dialog.open || rules.blocked(productId)) return;
    checking = true;
    try {
      const cart = await readCart();
      const product = cart.items.find(item => Number(item.product_id) === productId);
      if (!product) return;
      const showBag = dialog.dataset.bagAvailable === 'true'
        && !rules.inCart(dialog.dataset.bagProduct, cart.items)
        && await hasBagTag(product.handle);
      bagRow.hidden = !showBag;
      bag.checked = false;
      if (showBag) bagRow.querySelector('img[data-src]').src = bagRow.querySelector('img').dataset.src;
      const canOfferAddons = rules.canOffer(productId)
        && !cart.items.some(item => rules.isAddonProduct(item.product_id))
        && !cart.discount_codes?.some(discount => discount.applicable);
      addonLimit = canOfferAddons ? rules.availableAddonSlots(cart.items) : 0;
      cards.forEach(card => {
        const show = canOfferAddons && !rules.inCart(card.dataset.addonProductId, cart.items);
        card.hidden = !show;
        card.querySelector('input').checked = false;
      });
      addonsHeading.hidden = !cards.some(card => !card.hidden);
      addonLimit = Math.min(addonLimit, cards.filter(card => !card.hidden).length);
      if (!showBag && addonsHeading.hidden) return;
      error.hidden = true;
      status.textContent = '';
      native.setAttribute('aria-hidden', 'true');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      dialog.showModal();
      dialog.scrollTop = 0;
      scrollHintDismissed = false;
      sync();
      requestAnimationFrame(updateScrollHint);
      visibleInputs()[0]?.focus({ preventScroll: true });
    } catch (_) {
      // The native cart notification remains usable if offer detection fails.
    } finally {
      checking = false;
    }
  });
})();
